export default (isOpen, overFlowValue = " ") => {
    if (isOpen) {
        document.body.style.overflow = overFlowValue;
    } else {
        document.body.style.overflow = null;
    }
};
